import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarningCardComponent } from './warning-card.component';



@NgModule({
  declarations: [WarningCardComponent],
  imports: [
    CommonModule
  ],
  exports:[WarningCardComponent]
})
export class WarningCardModule { }
